<script setup>
import { ref, watch } from 'vue';
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import FloatLabel from 'primevue/floatlabel';
import Textarea from 'primevue/textarea';
import { useToast } from 'primevue/usetoast';

const props = defineProps({
  visible: Boolean,
  contact: Object, // null для нового, объект для редактирования
});
const emit = defineEmits(['update:visible', 'close', 'save']);

const toast = useToast();

const emptyForm = {
  name: '',
  post: '',
  email: '',
  comments: '',
  phone: '',
};

const form = ref({ ...emptyForm });

// Инициализация формы при открытии диалога
watch(() => props.visible, (isVisible) => {
  if (isVisible) {
    if (props.contact) {
      // Редактирование
      const incoming = { ...emptyForm, ...props.contact };
      if (!incoming.phone && Array.isArray(props.contact.phones) && props.contact.phones.length) {
        incoming.phone = props.contact.phones[0] || '';
      }
      form.value = incoming;
    } else {
      // Создание
      form.value = { ...emptyForm };
    }
  }
});


function close() {
  emit('update:visible', false);
  emit('close');
}

function submit() {
  const name = String(form.value.name || '').trim();
  if (!name) {
    toast.add({ severity: 'warn', summary: 'Проверьте форму', detail: 'Поле «Имя» обязательно', life: 3000 });
    return;
  }

  // Очень лояльная проверка email (если заполнен)
  const email = String(form.value.email || '').trim();
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // fgsdf@ksdf.com пройдет
  if (email && !emailRegex.test(email)) {
    toast.add({ severity: 'warn', summary: 'Проверьте email', detail: 'Некорректный формат email', life: 3000 });
    return;
  }


  const payload = {
    name,
    post: String(form.value.post || '').trim() || undefined,
    email: email || undefined,
    comments: String(form.value.comments || '').trim() || undefined,
    phone: String(form.value.phone || '').trim() || undefined,
  };

  emit('save', { id: props.contact?.id, data: payload });
}

</script>

<template>
  <Dialog
      :visible="visible"
      @update:visible="close"
      modal
      :header="contact ? 'Редактировать контакт' : 'Новый контакт'"
      :style="{ width: '400px' }"
      position="top"
      :closable="true"
  >
    <form @submit.prevent="submit" class="flex flex-col gap-8 p-fluid pt-2">
      <FloatLabel variant="on">
        <InputText id="contact_name" v-model="form.name" required autocomplete="off" class="w-full"/>
        <label for="contact_name">Имя*</label>
      </FloatLabel>

      <FloatLabel variant="on">
        <InputText id="contact_post" v-model="form.post" autocomplete="off" class="w-full"/>
        <label for="contact_post">Должность</label>
      </FloatLabel>

      <FloatLabel variant="on">
        <InputText
            id="contact_phone"
            v-model="form.phone"
            mask="+7(999)999-99-99"
            placeholder="+7(900)123-45-67"
            :autoClear="false"
            class="w-full"
        />
        <label for="contact_phone">Телефон</label>
      </FloatLabel>

      <FloatLabel variant="on">
        <InputText
            id="contact_email"
            v-model="form.email"
            type="email"
            inputmode="email"
            placeholder="name@example.com"
            class="w-full"
            autocomplete="off"
        />
        <label for="contact_email">Email</label>
      </FloatLabel>

      <FloatLabel variant="on">
        <Textarea id="contact_comments" v-model="form.comments" autoResize rows="3" class="w-full"/>
        <label for="contact_comments">Комментарии</label>
      </FloatLabel>



      <div class="flex justify-center gap-4 pt-2">
        <Button :label="contact ? 'Сохранить' : 'Добавить'" type="submit" severity="info" rounded />
        <Button label="Отмена" type="button" severity="secondary" rounded @click="close" />
      </div>

    </form>
  </Dialog>
</template>